
export class DynamicLayout {
  constructor (scene, parentbox) {
    this.scene = scene
    this.parentbox = parentbox
    this.visibleSubboxes = this.getVisibleSubboxes(parentbox.boxes)
    this.complete = Object.values(this.parentbox.boxes).length === Object.values(this.visibleSubboxes).length

    this.totalWidthOfSubboxes = 0
    Object.values(this.visibleSubboxes).forEach(vbox => { this.totalWidthOfSubboxes += vbox.width })
    this.horizontalSpaces = Math.max(this.parentbox.width - this.totalWidthOfSubboxes, 0)

    this.totalHeightOfSubboxes = 0
    Object.values(this.visibleSubboxes).forEach(vbox => { this.totalHeightOfSubboxes += vbox.height })
    this.verticalSpaces = Math.max(this.parentbox.height - this.totalHeightOfSubboxes, 0)
  }

  getVisibleSubboxes (boxes) {
    const subboxes = {}
    Object.values(boxes).sort((boxa, boxb) => boxa.zindex < boxb.zindex).forEach(box => {
      if (Object.values(this.scene.contents).find(content => content.box === box.id && content.active)) {
        subboxes[box.id] = { ...box }
      }
    })
    return subboxes
  }

  getTop (subbox) {
    if (this.parentbox['vertical-align'] === 'center') {
      return this.getCenteredTop(subbox)
    }
    return this.parentbox.top
  }

  getLeft (subbox) {
    if (this.parentbox['horizontal-align'] === 'center') {
      return this.getCenteredLeft(subbox)
    }
    return this.parentbox.left
  }

  getCenteredLeft (subbox) {
    if (!this.visibleSubboxes[subbox.id] === undefined) {
      return 0
    }
    const index = Object.values(this.visibleSubboxes).filter(vbox => vbox.zindex > subbox.zindex).length
    let totalWidthBeforeMe = 0
    Object.values(this.visibleSubboxes).forEach(vbox => {
      if (vbox.zindex > subbox.zindex) {
        totalWidthBeforeMe += vbox.width
      }
    })
    if (this.complete) {
      const spaces = this.horizontalSpaces / (Object.values(this.visibleSubboxes).length - 1)
      return this.parentbox.left + index * spaces + totalWidthBeforeMe
    } else {
      const spaces = this.horizontalSpaces / (Object.values(this.visibleSubboxes).length + 1)
      return this.parentbox.left + (index + 1) * spaces + totalWidthBeforeMe
    }
  }

  getCenteredTop (subbox) {
    if (!this.visibleSubboxes[subbox.id] === undefined) {
      return 0
    }
    const index = Object.values(this.visibleSubboxes).filter(vbox => vbox.zindex > subbox.zindex).length
    let totalHeightBeforeMe = 0
    Object.values(this.visibleSubboxes).forEach(vbox => {
      if (vbox.zindex > subbox.zindex) {
        totalHeightBeforeMe += vbox.height
      }
    })
    if (this.complete) {
      const spaces = this.verticalSpaces / (Object.values(this.visibleSubboxes).length - 1)
      return this.parentbox.top + index * spaces + totalHeightBeforeMe
    } else {
      const spaces = this.horizontalSpaces / (Object.values(this.visibleSubboxes).length + 1)
      return this.parentbox.top + (index + 1) * spaces + totalHeightBeforeMe
    }
  }
}
